import React from 'react'
function Face() {
    return (
        <svg
        width="78"
        height="80"
        viewBox="0 0 63 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.677 22C14.0934 22 11.8125 19.3854 11.8125 16C11.8125 12.6146 14.0934 10 17.677 10H17.8393C21.4275 10 23.625 12.6099 23.625 16C23.625 19.3901 21.4275 22 17.8393 22H17.677ZM45.2395 22C41.6559 22 39.375 19.3854 39.375 16C39.375 12.6146 41.6559 10 45.2395 10H45.4018C48.99 10 51.1875 12.6099 51.1875 16C51.1875 19.3901 48.99 22 45.4018 22H45.2395ZM13.875 40C10.5613 40 7.875 42.6863 7.875 46C7.875 49.3137 10.5613 52 13.875 52H49.125C52.4387 52 55.125 49.3137 55.125 46C55.125 42.6863 52.4387 40 49.125 40H13.875Z" fill="url(#paint0_linear)"/>
        <defs>
        <linearGradient id="paint0_linear" x1="-15.75" y1="31" x2="25.9603" y2="77.9241" gradientUnits="userSpaceOnUse">
        <stop stop-color="#0075C9"/>
        <stop offset="1" stop-color="#76C2B6"/>
        </linearGradient>
        </defs>
        </svg>
    );
}
export default Face